export const ACTION_RESET = 'FETCH_BRANDSPAGE_RESET';
export const ACTION_REQUEST = 'FETCH_BRANDSPAGE_REQUEST';
export const ACTION_SUCCESS = 'FETCH_BRANDSPAGE_SUCCESS';
export const ACTION_ERROR = 'FETCH_BRANDSPAGE_ERROR';
